export default {
  path: '/sales-map',
  name: 'sales-map',
  component: () => import('@/modules/sales-map/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        content: 'Great tools to help you grow your Etsy shop into a thriving business.',
        name: 'description',
      },
      {
        page_slug: 'sales-map',
      },
      {
        name: "google",
        content: "notranslate",
      },
    ],
    requiresAuth: true,
    title: 'eRank — Sales Map',
  },
};
